<template>
  <router-link :to="to" class="link" :class="{ active: isActive }">
    <div class="link-container" :class="{ active: isActive }">
      <ul>
        <li>
          <img class="icon" :class="{ active: isActive }" v-bind:src="require(`../assets/sidebar/${icon}.svg`)" alt="" />
        </li>
        <li :class="{ invisible: name == '' }">
          <span class="buttonName" :class="{ active: isActive }">{{ name }}</span>
        </li>
      </ul>
      <transition name="fade"> </transition>
    </div>
  </router-link>
</template>

<script>
// eslint-disable-next-line no-unused-vars

export default {
  props: {
    to: { type: String, required: true },
    icon: { type: String, required: true },
    name: { type: String, required: true },
  },
  mounted() {},
  watch: {
    $route(to, from) {
     
      // New route
      if (this.name.toLowerCase() == to.name.toLowerCase()) {
        this.isActive = true;
      }
      // Remove active from old route
      if (from.name != null && from.name.toLowerCase() == this.name.toLowerCase()) {
        this.isActive = false;
      }
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
};
</script>

<style scoped>
.buttonName {
  font-size: 0.75em;
  color: rgba(255, 255, 255, 1);
}

ul {
  padding: 0em;
  list-style-type: none;
  margin: 0em;
  height: 80px;
}
.v-application ol,
.v-application ul {
  padding: 0.0em;
  margin: 0em;
}

.v-application ul,
.v-application ol {
  padding: 0em;
  margin: 0em;
}

li {
  display: list-item;
  text-align: center;
  margin: 0em;
  padding: 0em;
  height: 42px;
}
.icon {
}
/* .icon.active {
  filter: invert(51%) sepia(73%) saturate(3610%) hue-rotate(211deg) brightness(93%) contrast(95%);
} */

.link-container {
  font-weight: 400;
  user-select: none;

  color: black;

  margin: 1em 0em;
  padding: 0em;
  align-items: center;
  height: 72px;

  position: relative;
}

.link-container.active {
  transition: 0.3s ease;
  background-color: rgba(255, 255, 255, 0.16);
  cursor: default;
}

.link {
  align-items: center;

  position: relative;
  font-weight: 400;
  user-select: none;


  margin: 0em 0em;
  padding: 0em;

  color: black;
  text-decoration: none;
}

.link-container:hover {
  transition: 0.3s ease;

  background-color: rgba(255, 255, 255, 0.16);
}
li.invisible {
  visibility: hidden;
}
/* .buttonName.active {
  transition: 0.3s ease;
  color: #5774e7;
} */

.link .icon {
  width: 32px;
  height: 32px;
  margin: 0em 0em;
  padding: 0em;
  margin-top: 9px;
}
</style>
